import React from 'react';
import cn from 'classnames';

import StoreCard from '../StoreCard';

import {IStoreCardListProps} from './IStoreCardList';

import styles from './StoreCardList.module.scss';

const StoreCardList = ({stores, visible}: IStoreCardListProps) => {
	return (
		<div className={cn([styles['store-card-list'], {[styles['store-card-list--visible']]: visible}])}>
			<div className={styles['store-card-list__wrapper']}>
				<div className={styles['store-card-list__wrapper__cards']}>
					{stores.map((store) => (
						<StoreCard key={`${store.ID}`} store={store} />
					))}
				</div>
			</div>
		</div>
	);
};

export default StoreCardList;
